<template>
  <div class="user-box">
    <ul class="select-option">
      <li>
        <el-input
          v-model="beanName"
          placeholder="bean名称"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <el-button type="primary" icon="el-icon-search" @click.stop="search">
          查询
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:save', permList)">
        <el-button type="primary" icon="iconfont icon-plus" @click.stop="add">
          增加
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:update', permList)">
        <el-button type="primary" icon="iconfont icon-xiugai" @click.stop="revise">
          修改
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:delete', permList)">
        <el-button
          type="primary"
          icon="iconfont icon-delet"
          @click.stop="todo('删除', 'delete')"
        >
          删除
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:pause', permList)">
        <el-button
          type="primary"
          icon="el-icon-video-pause"
          @click.stop="todo('暂停', 'pause')"
        >
          暂停
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:resume', permList)">
        <el-button
          type="primary"
          icon="el-icon-video-play"
          @click.stop="todo('恢复', 'resume')"
        >
          恢复
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:run', permList)">
        <el-button
          type="primary"
          icon="el-icon-right"
          @click.stop="todo('立即执行', 'run')"
        >
          立即执行
        </el-button>
      </li>
      <li v-if="checkPermission('sys:schedule:log', permList)" style="float: right">
        <el-button type="danger" icon="iconfont icon-log" @click.stop="log">
          日志列表
        </el-button>
      </li>
    </ul>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />
      <el-table-column type="selection" width="50" align="center" />
      <el-table-column label="任务ID" width="110" prop="jobId" align="center" sortable />
      <el-table-column prop="beanName" label="bean名称" sortable />
      <el-table-column
        prop="methodName"
        label="方法名称"
        show-overflow-tooltip
        sortable
      />
      <el-table-column prop="params" label="参数" show-overflow-tooltip sortable />
      <el-table-column
        prop="cronExpression"
        label="corn表达式"
        show-overflow-tooltip
        sortable
      />
      <el-table-column prop="remark" label="备注" show-overflow-tooltip sortable />
      <el-table-column
        prop="status"
        label="状态"
        show-overflow-tooltip
        width="100"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" type="success" label="正常" effect="dark">
            正常
          </el-tag>
          <el-tag v-else type="danger" label="禁用" effect="dark">禁用</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      limit: 10,
      pageIndex: 1,
      beanName: '',
      sidx: '',
      order: 'asc',
      tableData: {},
      selectRows: []
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.jobId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '定时任务')
    this.getUserList(this.limit, this.pageIndex, this.beanName, this.sidx, this.order)
  },

  methods: {
    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    getUserList(limit, pageIndex, beanName, sidx, order) {
      const vm = this
      vm.axios
        .get(this.homePath() + '/sys/schedule/list', {
          params: {
            limit: limit,
            page: pageIndex,
            beanName: beanName,
            sidx: sidx,
            order: order
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.tableData = data.page
          } else if (data.status === '100000') {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback() {
                vm.$router.push('/index/user')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.getUserList(this.limit, this.pageIndex, this.beanName, this.sidx, this.order)
    },

    add() {
      this.$router.push('/index/addschedule')
    },

    log() {
      this.$router.push('/index/schedulelog')
    },

    revise() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })

        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.$router.push('/index/reviseschedule/' + vm.selectRows[0].jobId)
    },

    todo(text, act) {
      const vm = this
      vm.$confirm('确定要' + text + '选中的记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vm.axios
            .post(vm.homePath() + '/sys/schedule/' + act, vm.selectRowsId)
            .then((response) => {
              if (response.data.status === '000000') {
                vm.$message({
                  type: 'success',
                  message: '操作成功!'
                })

                this.getUserList(
                  this.limit,
                  this.pageIndex,
                  this.beanName,
                  this.sidx,
                  this.order
                )
              } else {
                console.log(response.data.message)
              }
            })
            .catch((error) => console.log(error))
        })
        .catch(() => {
          vm.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    pageChange(val) {
      this.pageIndex = val
      this.getUserList(this.limit, this.pageIndex, this.beanName, this.sidx, this.order)
    }
  }
}
</script>
